import { Dispatch, SetStateAction } from 'react'
import { RadioGroup } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'
import classNames from 'classnames'

interface RadioProps {
	label?: string
	value?: string
}

interface RadioMultipleProps {
	itens: Array<RadioProps>
	selectedItem: Array<string>
	setSelectedItem: Dispatch<SetStateAction<string[]>>
	classname?: string
}

export default function RadioMultiple({
	itens,
	classname,
	selectedItem,
	setSelectedItem,
}: RadioMultipleProps) {
	return (
		<div className='w-full'>
			<div className={twMerge('w-full', classname)}>
				<RadioGroup value={selectedItem} onChange={setSelectedItem}>
					<RadioGroup.Label className='sr-only'>Server size</RadioGroup.Label>
					<div className='flex flex-wrap gap-2'>
						{itens.map((item, idx) => (
							<RadioGroup.Option
								key={idx}
								value={item.value}
								className={({ checked }) =>
									twMerge(
										'relative flex min-w-max gap-3 py-1 px-3 rounded-full dark:bg-brand-fluency/5 dark:hover:bg-brand-primary text-black dark:text-[#000000]/40 leading-normal cursor-pointer items-center justify-center focus:outline-none group transition-colors duration-300',
										classNames({
											'border-brand-primary bg-brand-primary/15 dark:text-brand-text-primary dark:bg-brand-primary dark:font-medium':
												checked ||
												(item?.value &&
													selectedItem?.includes(item.value.toString())),
										})
									)
								}
							>
								{({ checked }) => (
									<>
										<div className='flex w-full items-center justify-between'>
											<div className='flex items-center'>
												<div className='flex text-sm items-center gap-3'>
													<RadioGroup.Label
														as='p'
														className={twMerge(
															'text-sm font-medium dark:text-[#000000]/40 dark:group-hover:text-white transition-colors duration-300',
															classNames({
																'dark:text-white':
																	checked ||
																	(item?.value &&
																		selectedItem?.includes(
																			item.value.toString()
																		)),
															})
														)}
													>
														{item.label}
													</RadioGroup.Label>
												</div>
											</div>
										</div>
									</>
								)}
							</RadioGroup.Option>
						))}
					</div>
				</RadioGroup>
			</div>
		</div>
	)
}
